import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Nav";
import firebase from "firebase";
import LoadingPage from "../components/LoadingPage";

//redux
import { connect } from "react-redux";

class parkingUserData extends Component {
  state = {
    parking_users: [],
    loading: true
  };

  componentDidMount() {
    this.retrieveData();
  }

  retrieveData = async () => {
    let tableMarkup = [];

    const db = firebase.firestore();
    let datesFromDb = await db
      .collection("parking")
      .doc("parking_users")
      .get()
      .then(dates => {
        return dates.data().dates;
      });

    datesFromDb.map(async date => {
      await db
        .collection("parking")
        .doc("parking_users")
        .collection(date)
        .get()
        .then(document => {
          document.docs.forEach(user => {
            let newUserToTable = {};
            console.log(user.data());
            newUserToTable.plateNumber = user.id;
            newUserToTable.date = user.data().entryDateTime.split(", ")[0];
            newUserToTable.entry = user.data().entryDateTime.split(", ")[1];
            newUserToTable.exit = user.data().exitDateTime
              ? user.data().exitDateTime.split(", ")[1]
              : "In Use";
            tableMarkup = [...tableMarkup, newUserToTable];
            console.log(tableMarkup);
            this.setState({ parking_users: tableMarkup });
          });
        });
    });

    this.setState({ loading: false });
  };

  render() {
    const { user } = this.props;

    const data = {
      columns: [
        {
          label: "Plate Number",
          field: "plateNumber",
          sort: "asc",
          width: 150
        },
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 150
        },
        {
          label: "Entry",
          field: "entry",
          sort: "asc",
          width: 150
        },
        {
          label: "Exit",
          field: "exit",
          sort: "asc",
          width: 150
        }
      ],
      rows: [...this.state.parking_users]
    };

    return (
      <div>
        <Navbar />

        {this.state.loading ? (
          <LoadingPage />
        ) : (
            <div class="row content-div">
              {user.role === "admin" && (
                <div class="col-md-2 d-md-block sidebar sidebar-parking-logs">
                  <Sidebar />
                </div>
              )}
              <MDBDataTable striped hover data={data} className="col-lg-10 p-5" />
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(parkingUserData);
